import { render, staticRenderFns } from "./TeacherPage.vue?vue&type=template&id=45563c58&"
import script from "./TeacherPage.vue?vue&type=script&lang=js&"
export * from "./TeacherPage.vue?vue&type=script&lang=js&"
import style0 from "./TeacherPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TeacherPage.vue"
export default component.exports